import axiosInstance from "../axiosInstance";
import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

// export const getManagerList = () =>{
//     try{
//         const res = axiosInstance.get(`${endpoints.manager.managerList}`);
//         return res

//     }catch(error){
//         return error
//     }
// }

export const getManagerList = async (apidata, pageParam) => {
  try {
    const res = await axiosInstance.get(
      `${endpoints.manager.managerList}?status=${apidata?.status}&search=${apidata?.search}&from=${apidata?.startDate}&to=${apidata?.endDate}&page=${pageParam}`
    );

    return res?.data;
  } catch (error) {
    return error;
  }
};

// export const getManagerListBySearch = (search) =>{
//     try{
//         const res = axiosInstance.get(`${endpoints.manager.managerList}?search=${search}`);
//         return res

//     }catch(error){
//         return error
//     }
// }

// export const getManagerListByDate = (date) =>{
//     try{
//         const res = axiosInstance.get(`${endpoints.manager.managerList}?created_at_From=${date.startDate}&created_at_to=${date.endDate}`);
//         return res

//     }catch(error){
//         return error
//     }
// }

export const createManager = async (body) => {
  try {
    const res = await axiosInstance.post(endpoints.manager.createManager, body);
    return res;
  } catch (error) {
    return error.message;
  }
};

export const submissionData = async () => {
  try {
    const res = await axiosInstance.post(endpoints.manager.managerSummary);
    return res;
  } catch (error) {
    return error.message;
  }
};

export const copywriterssubmissionData = async () => {
  try {
    const res = await axiosInstance.post(
      endpoints.copyWritersDashboard.submissions
    );
    return res;
  } catch (error) {
    return error.message;
  }
};
export const fetchManagers = () => {
  // console.warn("call manager");
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.users.byRole, { role: [7] })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getManagerVideos = async (datas) => {
  // let duplicate = ""
  // let qualityTeamdecision = ""
  // data?.duplicateStatus=="yes"? duplicate = `&duplicate=${data?.duplicateStatus}`: duplicate = "";

  // `${data?.quality_team_decision}`? qualityTeamdecision = `&quality_team_decision=${data?.quality_team_decision}` : qualityTeamdecision = ""
  // try {
  //     const res = axiosInstance.get(`${endpoints.videos.videos}?manager_id=${data.managerId}&page=${data?.page}&manager_decision=${data?.manager_decision}${qualityTeamdecision}${duplicate}`)
  //     return res
  // } catch (error) {
  //     return error.message
  // }
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.videos.videos}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getManagerCardSubmission = async (data) => {
  try {
    const res = await axiosInstance.post(`${endpoints.cms.submissions}`, data);
    return res;
  } catch (error) {
    return error.message;
  }
};

export const managerAccountToAssign = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${endpoints.manager.managerAssign}`,
      data
    );
    return res;
  } catch (error) {
    return error.message;
  }
};
export const managerAssignUnassignList = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${endpoints.manager.managerAssignUnassignList}?manager_id=${data?.manager_id}`
    );
    return res?.data;
  } catch (error) {
    return error.message;
  }
};

export const managerCardProfile = async (data) => {
  try {
    const res = await axiosInstance.get(
      `${endpoints.manager.managerCardProfile}?user_id=${data}`
    );
    return res;
  } catch (error) {
    return error.message;
  }
};
